<template>
	<div class="ms-cell-editor">
		<ms-checkbox
			:value="dataRow[col.dataField]"
			size="small"
			v-model="dataRow[col.dataField]"
			:disabled="readOnly || !editable"
			@change="changeHandler"
		/>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
export default {
	name: 'MsCellCheckbox',
	extends: msCellInput,
	methods: {
		changeHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				cell: me,
			};
			me.$emit('change', metaData);
		},
	},
};
</script>
